var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,attrs:{"id":"profile"}},[(_vm.picture === '')?_c('span',[_vm._v(_vm._s(_vm.initials))]):_c('img',{staticClass:"avatar-image",attrs:{"src":_vm.picture,"alt":_vm.initials}})])
}
var staticRenderFns = []

export { render, staticRenderFns }